import { convertEnumToKeyValueList } from '../../../../app.misc';
import { find as _find } from 'lodash';
import { without as _without } from 'lodash';

class AutoPromiseContainerController {
  constructor(authService, $scope, $ngConfirm, enums, autoPromiseMagementService, loadingService, $stateParams) {
    "ngInject";

    this.authService = authService;
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;    
    this.enums = enums;
    this.autoPromiseMagementService = autoPromiseMagementService;
    this.loadingService = loadingService;
    this.$stateParams = $stateParams;

    this.autoPromises = [];

    this.listAutoPromises();
  }

  showAutoPromiseAdd(){
    this.$scope.errMsg = '';
    this.$scope.autoPromiseTriggers = convertEnumToKeyValueList(this.enums.AUTO_PROMISE_TRIGGER, true);
    this.$scope.timeSpanTypes = convertEnumToKeyValueList(this.enums.TIMESPAN_TYPE, true);

    this.$scope.autoPromise = {
      entityId: this.$stateParams.locationId,
      autopromiseTrigger: null,
      timespanType: null,
      timespan: 0,
      subject: null
    };

    this.$ngConfirm({
      title: 'Add Automatic Promise',
      contentUrl: `templates/promise/autoPromiseTemplate`,
      typeAnimation: false,
      columnClass: 'l',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: () => { 
              let valid = this.validateAutoPromise();

              if (valid){
                this.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');

                this.autoPromiseMagementService.add(this.$stateParams.locationId, this.$scope.autoPromise)
                  .then(response => {
                    this.autoPromises.push(response.data);
                  })
                  .finally(() => {
                    this.loadingService.hideLoading('autoPromiseList');
                  });
              }
              else{
                return false;
              }            
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }

  listAutoPromises() {    
    this.loadingService.showLoading('autoPromiseList', 'Loading Autopromises ...');

    this.autoPromiseMagementService.list(this.$stateParams.locationId)
      .then(response => {
        this.autoPromises = response.data.items;
      })
      .finally(() => {
        this.loadingService.hideLoading('autoPromiseList');
      });
  }

  validateAutoPromise() {
    if(this.$scope.autoPromise.autopromiseTrigger == null){
      this.$scope.errMsg = 'Please select a Trigger';

      return false;
    }

    if(this.$scope.autoPromise.timespanType == null || this.$scope.autoPromise.timespan === 0){
      this.$scope.errMsg = 'Please specify a valid duration';

      return false;
    }    

    if(!this.$scope.autoPromise.subject){
      this.$scope.errMsg = 'Please specify the subject';

      return false;
    }        

    return true;
  }

  removeAutoPromise(autoPromiseId){
    this.$ngConfirm({
      title: null,
      content: `Are you sure you want to remove this Automatic Promise`,
      typeAnimation: false,
      columnClass: 'm',
      type: 'red',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Remove',
            btnClass: 'btn-danger',
            action: () => { 
                this.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');

                this.autoPromiseMagementService.remove(this.$stateParams.locationId, autoPromiseId)
                  .then(response => {
                    const autoPromise = _find(this.autoPromises, o => o.automaticPromiseId === autoPromiseId);
                    this.autoPromises =  _without(this.autoPromises, autoPromise);
                  })
                  .finally(() => {
                    this.loadingService.hideLoading('autoPromiseList');
                  });      
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }  

  showAutoPromiseEdit(autoPromise){
    this.$scope.errMsg = '';
    this.$scope.autoPromiseTriggers = convertEnumToKeyValueList(this.enums.AUTO_PROMISE_TRIGGER, true);
    this.$scope.timeSpanTypes = convertEnumToKeyValueList(this.enums.TIMESPAN_TYPE, true);

    this.$scope.autoPromise = {
      automaticPromiseId: autoPromise.automaticPromiseId,
      entityId: autoPromise.entityId,
      autopromiseTrigger: autoPromise.autopromiseTrigger,
      timespanType: autoPromise.timespanType,
      timespan: autoPromise.timespan,
      subject: autoPromise.subject
    };

    this.$ngConfirm({
      title: 'Edit Automatic Promise',
      contentUrl: `templates/promise/autoPromiseTemplate`,
      typeAnimation: false,
      columnClass: 'l',
      scope: this.$scope,
      buttons: {
        yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: () => { 
              let valid = this.validateAutoPromise();

              if (valid){
                this.loadingService.showLoading('autoPromiseList', 'Saving Changes ...');

                this.autoPromiseMagementService.edit(this.$stateParams.locationId, this.$scope.autoPromise)
                  .then(response => {
                    autoPromise = Object.assign(autoPromise, response.data);
                  })
                  .finally(() => {
                    this.loadingService.hideLoading('autoPromiseList');
                  });
              }
              else{
                return false;
              }            
            }
        },
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }
}

export default AutoPromiseContainerController;



// WEBPACK FOOTER //
// ./client/app/components/admin/autoPromiseManagement/autoPromiseContainer/autoPromiseContainer.controller.js